module.exports = __webpack_public_path__ + "static/Image2TEAM-75472a3030b0f25754dbad42bc4374ee.png";